import { ReactElement, ReactNode } from "react"
import { useParams } from "react-router-dom"

import CreateDeviceProvider from "./baseProviders/createDeviceProvider"
import useGetTTRDeviceFormDataFromApiResponse from "../../../../hooks/useGetTTRDeviceFormDataFromApiResponse"
import useStartNewVersion from "../../../../services/middleware/hooks/devices/ttr/useStartNewVersion"

interface INewDeviceVersionFormUrlParam {
    deviceRef: string
}

interface INewDeviceVersionProviderProps {
    children: ReactNode
}

const NewDeviceVersionProvider = ({
    children,
}: INewDeviceVersionProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof INewDeviceVersionFormUrlParam
    >() as INewDeviceVersionFormUrlParam

    const {
        data,
        isLoading,
        isValidating,
        error: newVersionError,
    } = useStartNewVersion(urlDeviceRef)

    const { formData, setFormData } = useGetTTRDeviceFormDataFromApiResponse(
        isLoading,
        isValidating,
        newVersionError,
        data
    )

    return (
        <CreateDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={newVersionError}
            deviceId={data?.DeviceID}
            deviceRef={data?.DeviceRef}
            canEditManufacturer={false}
        >
            {children}
        </CreateDeviceProvider>
    )
}

export default NewDeviceVersionProvider
